import {DataFetcher} from '@aboutyou/data-fetcher';
import {DeliveriesSkeleton} from '@aboutyou/ui-components';
import React from 'react';
import {useDeliveriesSection} from '../hooks/useGetBasketPageSection';
import {DeliveriesView} from './DeliveriesView';

export interface DeliveriesProps {
  showLowestPrice?: boolean;
  removeProductTileSecondaryPriceLabel?: boolean;
  onBasketQuantityChange?: (props: {isMovReached?: boolean}) => void;
  onBasketItemRemovedSuccessfully?: VoidFunction;
}

export const Deliveries: React.FC<DeliveriesProps> = props => {
  return (
    <DataFetcher
      request={useDeliveriesSection()}
      View={DeliveriesView}
      Error={() => null}
      Loading={DeliveriesSkeleton}
      viewProps={props}
    />
  );
};
